module.exports = __webpack_public_path__ + "static/media/divaMain.c3301bc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/divaMain.jpg
// module id = 658
// module chunks = 0